import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { COMPETENCIES_URL } from './competencyService';

export const useCompetencyUrl = () => useEntityUrl({ baseLink: COMPETENCIES_URL });

export const useCompetencyId = () => useParams<Dictionary<string>>().id!;
